import { computed, type ComputedRef } from 'vue';
import { hasBetaAccess, waitForBetaOptIns } from '@/settings/subscription-settings/betas/betas.utils';
import { BETA_BY_ID } from '@/settings/subscription-settings/betas/betas.helpers';

// betas.helpers.js is untyped JS; BETA_BY_ID infers as `{}` for TS consumers.
const spacesBeta = (BETA_BY_ID as Record<string, unknown>).spaces;

export function hasSpacesBetaAccess (): boolean {
    return hasBetaAccess(spacesBeta);
}

// Reactive counterpart for components that build a menu once and need to rebuild it if enrollment
// state loads after mount — hasSpacesBetaAccess() alone doesn't trigger a re-render.
export function useSpacesBetaAccess (): ComputedRef<boolean> {
    return computed(() => hasBetaAccess(spacesBeta));
}

export async function waitForSpacesBetaOptIns (): Promise<void> {
    await waitForBetaOptIns(spacesBeta);
}
